<template>
  <div>
    <div v-for="(zoneItemConfig, itemIndex) in zoneConfigList" :key="zoneItemConfig.groupId">
      <template v-if="zoneItemConfig.busList && zoneItemConfig.busList[0]">
        <ip-zone-item
          :zone-item-config="zoneItemConfig"
          :pf-structure="pfStructure"
          :item-index="itemIndex"
          :change-subscribe-promp="changeSubscribePromp"
          :add-class-name="lastModule && itemIndex == zoneConfigList.length - 1 ? `${addClassName} list-my-game--style` : addClassName"
          :hide-subscribe="hideSubscribe"
        ></ip-zone-item>
        <!-- 间隔线 -->
        <div class="piece-line piece-line" :style="'display:' + displayPieceLine || ''"></div>
      </template>
    </div>
  </div>
</template>
<script>
import "es6-promise/auto"
import IpZoneItem from "./IpZoneItem.vue"

export default {
  name: "IpZoneList",
  components: {
    IpZoneItem
  },
  props: {
    zoneConfigList: Array,
    pfStructure: String,
    changeSubscribePromp: Function,
    addClassName: String,
    displayPieceLine: String,
    lastModule: { type: Boolean, default: false },
    hideSubscribe: { type: Boolean, default: false }
  }
}
</script>
